import { z } from 'zod';
/**
 * Player surface identity (ADR 0006).
 * Optional on wire so existing Android clients that omit these fields stay valid.
 */
export const DevicePlatformSchema = z.enum([
    'android_tv',
    'fire_tv',
    'web',
    'tizen',
    'webos',
    'brightsign',
    'unknown',
]);
export const DeviceCapabilitySchema = z.enum([
    'offline_cache',
    'schedule_eval',
    'cmd_sync_now',
    'cmd_clear_cache',
    'cmd_restart_player',
    'auto_start',
    'wake_lock',
    'panel_power',
    'reboot',
    'screenshot',
]);
/**
 * Additive identity / capability fields shared by pairing claim and sync.
 * Absence means unknown — not “full Android.”
 */
export const DeviceIdentityFieldsSchema = z.object({
    platform: DevicePlatformSchema.optional(),
    /** Player package build id, e.g. `android-1.2.0` or `web-0.1.0`. */
    playerBuild: z.string().min(1).optional(),
    capabilities: z.array(DeviceCapabilitySchema).optional(),
    /** OS / OEM name when the surface can read it (e.g. Build.MANUFACTURER). */
    manufacturer: z.string().trim().min(1).max(120).optional(),
    /** Device model when the surface can read it (e.g. Build.MODEL). */
    model: z.string().trim().min(1).max(120).optional(),
});
//# sourceMappingURL=device-identity.js.map